import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import {
  getDatasetMetricsByOrg
} from "../../../redux/actions/MetricsActions/Action";
import TimeRangeIndicator
  from "../../shared/Graph/TimeRangeIndicator/TimeRangeIndicator";
import StackedBarGraph from "../../shared/Graph/StackedBarGraph";
import EmptyGraph from "../../shared/Graph/EmptyGraph";
import Loader from "../../shared/Loader/Loader";
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { IconButton } from "@material-ui/core";
import { ENTITY_TYPES } from "../../../utility/constants/constants";
import { CloseFullscreen } from "@mui/icons-material";
import MetricsTable from "./MetricsTable";

const DatasetsUsageGraph = ({organizationId, graphTitle, graphOptions, expand, handleExpand, handleCollapse}) => {
  const dispatch = useDispatch();
  const datasetMetrics = useSelector((state) => state.metricsReducer.datasetMetrics);
  const [isDatasetMetricsLoaded, setIsDatasetMetricsLoaded] = useState(false);
  const [datasetsUsageTimeRange, setDatasetsUsageTimeRange] = useState('week')

  useEffect(() => {
    setIsDatasetMetricsLoaded(false)
    dispatch(getDatasetMetricsByOrg(organizationId, {
      period: datasetsUsageTimeRange,
    }))
  }, [dispatch, datasetsUsageTimeRange, organizationId])

  useEffect(() => {
    setIsDatasetMetricsLoaded(true)
  }, [datasetMetrics])

  const handleTimeChange = (event, newTime) => {
    if (newTime !== null) {
      setDatasetsUsageTimeRange(newTime)
    }
  }

  return (
    <>
      <div className={expand ? "panel entity_usage_details_graph_container" : "panel entity_usage_graph_container"}>
        <div className={expand ? "panel_header_row expanded" : "panel_header_row"}>
          {graphTitle && <div className="panel_description no_margin">{graphTitle}</div>}
          <div className="time_range_expand_icon_group">
            <TimeRangeIndicator timeRange={datasetsUsageTimeRange}
                                handleTimeChange={handleTimeChange}
                                className={"time_range_button_group align_items_end no_margin"} />
            {
              expand ?
                <IconButton onClick={() => handleCollapse()}>
                  <CloseFullscreen></CloseFullscreen>
                </IconButton> :
                <IconButton onClick={() => handleExpand(ENTITY_TYPES.DATASET)}>
                  <OpenInFullIcon></OpenInFullIcon>
                </IconButton>
            }
          </div>
        </div>
        <>
          {
            isDatasetMetricsLoaded ?
              <>
                {
                  Object.keys(datasetMetrics).length > 0 ?
                    <StackedBarGraph data={datasetMetrics} options={graphOptions}
                                     barLabels={Object.values(datasetMetrics).map(value => value.name)}
                                     barPercentage={0.2}
                                     barSectionLabels={Object.keys(Object.values(datasetMetrics)[0]).filter(el => el !== 'name')}
                                     className={expand ? "admin_portal_graph" : "entity_usage_graph"} /> :
                    <div className={"empty_graph_container"}>
                      <EmptyGraph />
                    </div>
                }
              </> :
              <Loader loading={!isDatasetMetricsLoaded}></Loader>
          }
        </>
      </div>
      {
        expand &&
        <MetricsTable organizationId={organizationId} show={expand} entity={"datasets"} timeRange={datasetsUsageTimeRange}></MetricsTable>
      }
    </>
  )
}

export default DatasetsUsageGraph